<template>
  <div v-rect-loading="loading" class="password-container">
    <div class="header">{{ $t(`${i18nPrefix}.title.changePassword`) }}</div>
    <div class="password-info-container">
      <WrappedForm
        ref="form"
        class="password-info"
        :data="passwordInfo"
        :formLine="formLine"
      >
      </WrappedForm>
      <div class="bottom-btn-group">
        <van-button class="save-btn" @click="handleSave">{{ $t('common.btn.submit') }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import WrappedForm from '@/components/mobile/resumeForm.vue'
import { passwordRegexp } from '@/utils/validator'

export default {
  components: {
    WrappedForm
  },
  data () {
    return {
      i18nPrefix: 'personal.functions.changePassword',
      loading: false,
      passwordInfo: {
        currentPassword: null,
        password: null,
        confirmPassword: null
      },
      showCurrentPassword: false,
      showPassword: false,
      showConfirmPassword: false
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount']),
    formLine () {
      const vm = this
      const lines = [
        {
          name: 'currentPassword',
          label: this.$t(`${this.i18nPrefix}.label.currentPassword`),
          get type () {
            return vm.showCurrentPassword ? 'text' : 'password'
          },
          rightIcon: 'eye',
          rules: [
            { required: true, message: this.$t('common.message.requiredFormField'), trigger: 'onBlur' }
          ],
          events: {
            'click-right-icon': () => {
              this.showCurrentPassword = !this.showCurrentPassword
            }
          }
        },
        {
          name: 'password',
          label: this.$t(`${this.i18nPrefix}.label.newPassword`),
          get type () {
            return vm.showPassword ? 'text' : 'password'
          },
          rightIcon: 'eye',
          rules: [
            { required: true, message: this.$t('common.message.requiredFormField'), trigger: 'onBlur' },
            { validator: this.validatePassword, trigger: 'onBlur' },
            { validator: this.validateSamePassword, trigger: 'onBlur' }
          ],
          events: {
            'click-right-icon': () => {
              this.showPassword = !this.showPassword
            }
          }
        },
        {
          name: 'confirmPassword',
          label: this.$t(`${this.i18nPrefix}.label.confirmPassword`),
          get type () {
            return vm.showConfirmPassword ? 'text' : 'password'
          },
          rightIcon: 'eye',
          rules: [
            { required: true, message: this.$t('common.message.requiredFormField'), trigger: 'onBlur' },
            { validator: this.validatePassword, trigger: 'onBlur' },
            { validator: this.validateSamePassword, trigger: 'onBlur' }
          ],
          events: {
            'click-right-icon': () => {
              this.showConfirmPassword = !this.showConfirmPassword
            }
          }
        }
      ]
      return lines
    },
    form () {
      return this.$refs.form
    },
    companyId () {
      return this.$route.query.company_id
    },
    back () {
      return this.$route.query.back
    }
  },
  created () {
  },
  methods: {
    ...mapActions('personal', ['updatePassword']),
    async handleSave () {
      const valid = await this.form.submit()
      if (!valid) {
        return
      }
      this.loading = true
      try {
        const passwordInfo = this.passwordInfo
        const resp = await this.updatePassword({
          old_password: passwordInfo.currentPassword,
          new_password: passwordInfo.password,
          confirm_password: passwordInfo.confirmPassword
        })
        if (resp) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.updateSuccess`))
          this.passwordInfo = {
            currentPassword: null,
            password: null,
            confirmPassword: null
          }
          this.onLeftIconClick()
        }
      } finally {
        this.loading = false
      }
    },
    async validatePassword (value, rule) {
      let errMsg = null
      if (!value || !passwordRegexp.test(value)) {
        errMsg = this.$t('common.message.invalidPwd')
      }
      if (errMsg) {
        rule.message = errMsg
        return false
      } else {
        return true
      }
    },
    async validateSamePassword (value, rule) {
      if (value && value === this.passwordInfo.currentPassword) {
        rule.message = this.$t(`${this.i18nPrefix}.message.passwordSameAsPrevious`)
        return false
      }
      if (!this.passwordInfo.password || !this.passwordInfo.confirmPassword) {
        return true
      }
      if (this.passwordInfo.password !== this.passwordInfo.confirmPassword) {
        rule.message = this.$t(`${this.i18nPrefix}.message.passwordNotSame`)
        return false
      }
    },

    onLeftIconClick () {
      if (this.back) {
        this.$router.push(this.back)
      } else {
        this.$router.push({ path: '/recruiting/personal/home', query: { company_id: this.companyId } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.password-container {
  .header {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #333;
  }

  .password-info-container {
    background-color: #fff;
    margin: 20px;
    padding: 20px 20px;
    border-radius: 4px;

    ::v-deep {
      .field-container {
        background-color: initial;

        .name {
          color: #606266;
        }

        .common-field {
          background-color: initial;
        }
      }
    }

    .bottom-btn-group {
      .save-btn {
        height: 40px;
        width: 100%;
        border-radius: 20px;
        color: #fff;
        background-color: #0096cc;
      }
    }
  }
}
</style>
